import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputSwitchNewComponent } from '../../components/input-switch-new/input-switch-new.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import UserRestServices from '../../services/user-rest.service';
import ChatRestServices from '../../services/chat-rest.service';
import Session from '../../utils/session.service';
import Toast from '../../services/toast.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';

@Component({
	standalone: true,
	selector: 'modal-chat-availability',
	templateUrl: './modal-chat-availability.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule, InputSwitchNewComponent ]
})
export class ModalChatAvailabilityComponent implements OnInit {
	private session: Session = inject(Session);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private toast: Toast = inject(Toast);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalChatAvailabilityComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.sessionUser = this.session.getSession().user;
		
		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.previsitLocation = true;
		}
		
		var lang: any = this.vm.sessionUser.deviceLanguage || 'en_GB';
		if (lang == 'en_GB' || lang == 'et_EE' || lang == 'ru_RU' || lang == 'fi_FI') {
			this.vm.appLogoLang = lang.split("_")[0];
		} else {
			this.vm.appLogoLang = 'en';
		}

		if (this.vm.sessionUser.origin == 'siffi.com') {
			this.vm.androidLink = 'https://play.google.com/store/apps/details?id=com.siffi&hl=' + this.vm.appLogoLang;
			this.vm.iosLink = 'https://apps.apple.com/app/siffi/id1629846508?platform=iphone';
		} else {
			this.vm.androidLink = 'https://play.google.com/store/apps/details?id=ee.minudoc&hl=' + this.vm.appLogoLang;
			this.vm.iosLink = 'https://apps.apple.com/app/minudoc/id1465732931?platform=iphone';
		}
		
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.hasNotificationsDisabled = !this.vm.extraInfo.myChatAvailability.hasEmailNotifications;
		
		this.vm.initialized = true;
		
		this.vm.close = this.close;
	}
	
	enableNotificationViaEmail = () => {
		this.userRestServices.enableChatNotification(
			{
				userId: this.vm.sessionUser.id,
				enableChatNotification: this.vm.hasNotificationsDisabled
			},
			(res) => {
				this.vm.hasNotificationsDisabled = !res.chatNotificationEnabled;
			},
			(err) => {
				console.log(err);
			}
		);
	}
	
	sendSms() {
		if (this.vm.sending) {
			return;
		}
		this.vm.sending = true;
		this.chatRestServices.sendNewMessagesNotification(
			{
				channel: 'SMS',
				platform: this.vm.previsitLocation ? 'eelvisiit' : null
			},
			{
				id: this.vm.user.id
			},
			(res) => {
				if (res && res.denied) {
					this.toast.showAsync(this.angularFilterHelperService.translate('Common.Denied'));
				} else {
					this.toast.showAsync(this.angularFilterHelperService.translate('Toast.Service.Message_Sent'));
				}
				this.vm.sending = false;
				console.log(res);
			},
			(err) => {
				this.toast.showAsync(this.angularFilterHelperService.translate('Common.Failed'));
				this.vm.sending = false;
				console.log(err);
			}
		);
	}
	
	sendEmail() {
		if (this.vm.sending) {
			return;
		}
		this.vm.sending = true;
		this.chatRestServices.sendNewMessagesNotification(
			{
				channel: 'EMAIL',
				platform: this.vm.previsitLocation ? 'eelvisiit' : null
			},
			{
				id: this.vm.user.id
			},
			(res) => {
				if (res && res.denied) {
					this.toast.showAsync(this.angularFilterHelperService.translate('Common.Denied'));
				} else {
					this.toast.showAsync(this.angularFilterHelperService.translate('Toast.Service.Message_Sent'));
				}
				this.vm.sending = false;
				console.log(res);
			},
			(err) => {
				this.toast.showAsync(this.angularFilterHelperService.translate('Common.Failed'));
				this.vm.sending = false;
				console.log(err);
			}
		);
	}
	
	close() {
		this.dialogRef.close();
	}
	
}